import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth, logInWithEmailAndPassword, signInWithGoogle } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import Header from "../components/Header";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    
    if (loading) {
      // maybe trigger a loading screen
      console.log("loading");
      return;
    }
    if (user) {
      console.log("user set");
      navigate("/dashboard");
    }
    return;
  }, [user, loading, error, navigate]);

  return (
    <>
    {loading === false ? (
    
    <div className="d-flex align-items-center flex-column mb-0 px-3 splashscreen">
      <Header key="1" user={user}/>
      
      <h2 className="p-2">Login</h2>

      <div className="p-2 loginbox">
        <form className="login_form" onSubmit={(e) => logInWithEmailAndPassword(e, email, password)} >
          <input
            type="email"
            className="textbox form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="E-mail"
            required
          />
          <input
            type="password"
            className="textbox form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            required
          />
          <button
            type="submit"
            className="btn btn-primary mb-2 py-2"
          >
            Login
          </button>
          <div className="text-center mb-5 to_passrecovery">
            <Link to="/reset">Forgot Password</Link>
          </div>
          <button className="btn btn-google py-2" onClick={signInWithGoogle}>
            Login with Google
          </button>
          
          <div>
            
          </div>
        </form>
      </div>

      <div className="mt-auto pb-5 to_registration text-center">
        <div>Don't have an account?<br/><Link to="/register">Sign up now!</Link></div>
        <div className="footer mt-3">Privacy - Cookie Policy - Contacts</div>
      </div>
    </div>

    ) : (
      <div className="loadingscreen">
        <div className="loading spinner-border text-warning"></div>
      </div>
    ) }
    </>
  );
}

export default Login;
